import { ApiClientError } from '~/ApiClient';
import Price from '~/utils/Price';

import FinalCalculation from './FinalCalculation';
import { mapCeilingPrice, RawCeilingPrice } from './mapCeilingPrice';
import { mapError } from './mapError';
import mapReferencedProduct, { RawReferencedProduct } from './mapReferencedProduct';

export interface RawFinalCalculation {
	biosimilarReferencePrice: Price | null;
	ceilingPrice: RawCeilingPrice | null;
	emptyResultReason: ApiClientError[];
	genericReferencePrice: Price | null;
	referencedProduct: RawReferencedProduct | null;
}

export const mapFinalCalculation = (finalCalculation: RawFinalCalculation): FinalCalculation => {
	const { biosimilarReferencePrice, ceilingPrice, genericReferencePrice, referencedProduct, emptyResultReason } =
		finalCalculation;

	return new FinalCalculation(
		biosimilarReferencePrice !== null
			? new Price(biosimilarReferencePrice.value, biosimilarReferencePrice.currency)
			: null,
		ceilingPrice !== null ? mapCeilingPrice(ceilingPrice) : null,
		emptyResultReason.map(mapError),
		genericReferencePrice !== null ? new Price(genericReferencePrice.value, genericReferencePrice.currency) : null,
		referencedProduct !== null ? mapReferencedProduct(referencedProduct) : null
	);
};
